<div class="pt-5">
    @if(loading) {
        <div class="flex w-full justify-center">
            <p-progress-spinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '50px', height: '50px' }" />
        </div>
    } @else if (stripeElementsOptions.clientSecret) {
        <ngx-stripe-elements
            [stripe]="ngxStripe"
            [elementsOptions]="stripeElementsOptions"
        >
            <ngx-stripe-payment [options]="paymentElementOptions" (change)="onPaymentChange($event)" />
        </ngx-stripe-elements>
        @if(addNewPaymentButtonProps.show) {
            <div class="my-4">
                <p-button
                    (click)="submit()"
                    [label]="'Add New Payment Card'"
                    [disabled]="!addNewPaymentButtonProps.enable"
                    class="[&_button]:bg-blue-500 [&_button]:border-0 [&_button]:text-white" />
            </div>
        } @else {
            <div class="my-4 text-xs text-gray-400">Please reach out to our support to remove your payment method on file. This is just to make sure we charged/refunded you for all your orders before we remove it. Appreciate for your support.</div>
        }
    } @else {
        <p-message severity="error">Something went wrong. Please try again later. If issue persits, please call us. Appreciate your support.</p-message>
    }
</div>